import { useBooks, useAuthors, useBitcoiners } from "@/hooks/use-sheets-data";
import { FeaturedBooks } from "@/components/featured-books";
import { FeaturedAuthors } from "@/components/featured-authors";
import { FeaturedBitcoiners } from "@/components/featured-bitcoiners";
import { useMemo } from "react";
import { Author, Bitcoiner, Book } from "@/types";

export function FeaturedSection() {
  const getRandomItems = useMemo(() => {
    function getRandomArray<T>(items: T[] | undefined | null): T[] {
      if (!items?.length) return [];
      const shuffled = [...items]
        .map(value => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      return shuffled.slice(0, 3);
    }
    return getRandomArray;
  }, []);

  const { data: books = [], isLoading: booksLoading } = useBooks();
  const { data: authors = [], isLoading: authorsLoading } = useAuthors();
  const { data: bitcoiners = [], isLoading: bitcoinersLoading } = useBitcoiners();

  const randomBooks = useMemo(() => getRandomItems(books), [books, getRandomItems]);
  const randomAuthors = useMemo(() => getRandomItems(authors), [authors, getRandomItems]);
  const randomBitcoiners = useMemo(() => getRandomItems(bitcoiners), [bitcoiners, getRandomItems]);

  if (booksLoading || authorsLoading || bitcoinersLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto space-y-20 py-8">
      {randomBooks.length > 0 && <FeaturedBooks books={randomBooks} />}
      {randomAuthors.length > 0 && <FeaturedAuthors authors={randomAuthors} />}
      {randomBitcoiners.length > 0 && <FeaturedBitcoiners bitcoiners={randomBitcoiners} />}
    </div>
  );
}